// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve = require("../Lunarbox.Control.Monad.Dataflow.Solve/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve_Unify = require("../Lunarbox.Control.Monad.Dataflow.Solve.Unify/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Constraint = require("../Lunarbox.Data.Dataflow.Constraint/index.js");
var solve$prime = function (substitution) {
    return function (v) {
        if (v instanceof Data_List_Types.Cons) {
            return Control_Bind.bind(Lunarbox_Control_Monad_Dataflow_Solve.bindSolve)(Control_Monad_Reader_Class.local(Lunarbox_Control_Monad_Dataflow_Solve.monadReaderSolve)(Data_Lens_Setter.set(Lunarbox_Control_Monad_Dataflow_Solve["_location"](Data_Profunctor_Strong.strongFn))(v.value0.source))(Lunarbox_Control_Monad_Dataflow_Solve_Unify.unify(v.value0.typeRight)(v.value0.typeLeft)))(function (substitution$prime) {
                return solve$prime(Data_Semigroup.append(Lunarbox_Data_Dataflow_Class_Substituable.semigroupSubstitution)(substitution$prime)(substitution))(Lunarbox_Data_Dataflow_Constraint.ConstraintSet(Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.arrSubst(Lunarbox_Data_Dataflow_Constraint.substiuableConstraint))(substitution$prime)(v.value1)));
            });
        };
        return Control_Applicative.pure(Lunarbox_Control_Monad_Dataflow_Solve.applicativeSolve)(substitution);
    };
};
var solve = solve$prime(Data_Monoid.mempty(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution));
module.exports = {
    solve: solve
};
